import { useMemo, useState } from 'react';
import { useUser } from '@/queries/useUser';
import { AnalyticsDateRangePicker, AnalyticsMetricsSection } from '@/features/analytics';
import { CHART_TYPES, type DateRangeObject } from '@/features/analytics/types/analytics.types';
import { RANGE_TYPES } from '@/features/analytics/constants/analytics.constants';
import { OnboardingChecklist } from './OnboardingChecklist';
import { GENERIC_STATUS } from '@/lib/constants';
import { useAllOnboardingTasksCompleted } from '@/hooks/useAllOnboardingTasksCompleted';

export function DefaultDashboard() {
    const { user } = useUser();

    const [dateRange, setDateRange] = useState<DateRangeObject>({
        startDate: new Date(new Date().setDate(new Date().getDate() - 14)),
        endDate: new Date(),
        rangeType: RANGE_TYPES.LAST_14_DAYS,
    });

    const showOnboardingDashboard = useMemo(() => {
        return user?.['onboarding-dashboard']?.status === GENERIC_STATUS.ACTIVE;
    }, [user]);

    // Check if all onboarding tasks are completed
    const { allTasksCompleted } = useAllOnboardingTasksCompleted();

    // Show checklist only if onboarding is active AND not all tasks are completed
    if (showOnboardingDashboard && !allTasksCompleted) {
        return <OnboardingChecklist />;
    }

    return (
        <div className='flex w-full flex-col gap-6'>
            <h1 className='heading-1'>Hey {user?.full_name || 'User'} - welcome back!</h1>

            <AnalyticsDateRangePicker onRangeSelected={setDateRange} />

            <AnalyticsMetricsSection dateRange={dateRange} initialChart={CHART_TYPES.REVENUE} />
        </div>
    );
}
